import getApiInstance from 'data/common/ApiCallGenerique';
import { Logger } from 'data/common';
import api from './api';
import { getSocket } from '../../common/AllSocketsMiddleware';

const apiCaller = getApiInstance();

function getProducts() {
    return dispatch => {
        return apiCaller
            .call(api.getAllProducts())
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__SET_PRODUCTS',
                        products: data.products
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheProducts - ', error);
                throw error;
            });
    };
}

function getProductsByHomeId(homeId) {
    return dispatch => {
        return apiCaller
            .call(api.getProductsByHomeId(homeId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__UPDATE_HOME_PRODUCTS',
                        products: data.products,
                        homeId
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheProducts - ', error);
                throw error;
            });
    };
}

function getProductsDetails(homeId, productType, productIdentifier) {
    let key = `${homeId}_${productType}_${productIdentifier}`;
    return dispatch => {
        return apiCaller
            .call(api.getProductsDetails(homeId, productType, productIdentifier))
            .then(({ data }) => {
                if (data.success) {
                    // data.productDetails[key]['productModules'] = data.productModules;
                    dispatch({
                        type: 'FHE__SET_PRODUCT_DETAILS',
                        // productKey: key,
                        product: data.productDetails
                        // productModules: data.productModules
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: setFheProductsDetails - ', error);
                throw error;
            });
    };
}

function deleteProduct(homeId, productType, productIdentifier, id) {
    return dispatch => {
        return apiCaller
            .call(api.deleteProduct(homeId, productType, productIdentifier, id))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: `FHE__PRODUCT_DELETE`,
                        productKey: `${homeId}_${productType}_${productIdentifier}`
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: deleteProduct - ', error);
                throw error;
            });
    };
}

function updateProductModuleLabel(middleware, fheCenter_mac, product_identifier, product_type, module_type, code, label) {
    return () => {
        return getSocket(middleware)
            .updateProductModuleLabel(fheCenter_mac, product_identifier, product_type, module_type, code, label)
            .catch(error => {
                Logger.log('dataActions: updateFheProductModuleMiddleware - ', error);
                throw error;
            });
    };
}
function refreshProductStatus(middleware, productMac, productType) {
    return () => {
        return getSocket(middleware)
            .genericProductCheckStatus(productMac, productType)
            .catch(error => {
                Logger.log('dataActions: refreshFheProductStatus - ', error);
                throw error;
            });
    };
}
function updateProductField(fieldName, homeId, identifier, type, fieldValue, moduleType) {
    let key = `${homeId}_${type}_${identifier}`;
    return dispatch => {
        return apiCaller
            .call(api.updateProductField(fieldName, homeId, identifier, type, fieldValue, moduleType))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__PRODUCT_UPDATE_FIELD',
                        productKey: key,
                        fieldName: fieldName,
                        fieldValue: fieldValue
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateFheProductField - ', error);
                throw error;
            });
    };
}
function dissociateProduct(fieldName, homeId, identifier, type, fieldValue, moduleType) {
    let key = `${homeId}_${type}_${identifier}`;
    return dispatch => {
        return apiCaller
            .call(api.dissociateProduct(fieldName, homeId, identifier, type, fieldValue, moduleType))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__PRODUCT_DISSOCIATE',
                        productKey: key,
                        fieldName: fieldName,
                        fieldValue: fieldValue
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: dissociateFheProduct - ', error);
                throw error;
            });
    };
}
function updateProductModule(homeId, identifier, productType, code, form, type, lineType, sensorId = null) {
    let productKey = `${homeId}_${productType}_${identifier}`;
    let productModuleKey = `${productType}_${identifier}_${code}`;
    return dispatch => {
        return apiCaller
            .call(api.updateProductModule(homeId, identifier, productType, code, form, type, lineType, sensorId))
            .then(({ data }) => {
                if (data.success) {
                    dispatch({
                        type: 'FHE__PRODUCT_MODULE_UPDATE',
                        productKey: productKey,
                        productModuleKey: productModuleKey,
                        form: form
                    });
                }
                return data;
            })
            .catch(error => {
                Logger.log('dataActions: updateFheProductModule - ', error);
                throw error;
            });
    };
}
function updateThreshold(middleware, fheCenter_mac, product_identifier, module_type, code, threshold) {
    return () => {
        return getSocket(middleware)
            .updateThreshold(fheCenter_mac, product_identifier, module_type, code, threshold)
            .catch(error => {
                Logger.log('dataActions: FheUpdateThresholdProductModule - ', error);
                throw error;
            });
    };
}
function updateGain(middleware, fheCenter_mac, product_identifier, module_type, code, gain) {
    return () => {
        return getSocket(middleware)
            .updateGain(fheCenter_mac, product_identifier, module_type, code, gain)
            .catch(error => {
                Logger.log('dataActions: FheUpdateGainProductModule - ', error);
                throw error;
            });
    };
}
function updateReversePolarity(middleware, fheCenter_mac, product_identifier, module_type, code, reversePolarity) {
    return () => {
        return getSocket(middleware)
            .updatePolarity(fheCenter_mac, product_identifier, module_type, code, reversePolarity)
            .catch(error => {
                Logger.log('dataActions: FheUpdateReversePolarityProductModule - ', error);
                throw error;
            });
    };
}
function resetRelaysInversions(middleware, fheCenter_mac, product_identifier, module_type) {
    return () => {
        return getSocket(middleware)
            .resetRelaysInversions(fheCenter_mac, product_identifier, module_type)
            .catch(error => {
                Logger.log('dataActions: FheResetRelaysInversionsProductModule - ', error);
                throw error;
            });
    };
}

/**** SENSOR ****/
function getSensorWifiList(middleware, fheCenter_mac) {
    return () => {
        return getSocket(middleware)
            .getSensorWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getSensorWifiListFhe - ', error);
                throw error;
            });
    };
}
function startSensorInclusion(middleware, fheCenter_mac, network, step_callback) {
    return () => {
        return getSocket(middleware)
            .startSensorInclusion(fheCenter_mac, network, step_callback)
            .catch(error => {
                Logger.log('dataActions: startSensorInclusionFhe - ', error);
                throw error;
            });
    };
}
/**** !SENSOR ****/

/**** SMARTPLUG ****/
function getSmartPlugWifiList(middleware, fheCenter_mac) {
    return () => {
        return getSocket(middleware)
            .getSmartPlugWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getSmartPlugWifiListFhe - ', error);
                throw error;
            });
    };
}
function startSmartPlugInclusion(middleware, fheCenter_mac, network, smartPlugAP, step_callback) {
    return () => {
        return getSocket(middleware)
            .startSmartPlugInclusion(fheCenter_mac, network, smartPlugAP, step_callback)
            .catch(error => {
                Logger.log('dataActions: startSmartPlugInclusionFhe - ', error);
                throw error;
            });
    };
}
/**** !SMARTPLUG ****/

/**** FHEPRODUCT ****/
function getFheProductWifiList(middleware, fheCenter_mac) {
    return () => {
        return getSocket(middleware)
            .getFheProductWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getFheProductWifiListFhe - ', error);
                throw error;
            });
    };
}
function startFheProductInclusion(middleware, fheCenter_mac, network, step_callback) {
    return () => {
        return getSocket(middleware)
            .startFheProductInclusion(fheCenter_mac, network, step_callback)
            .catch(error => {
                Logger.log('dataActions: startFheProductInclusionFhe - ', error);
                throw error;
            });
    };
}
/**** !FHEPRODUCT ****/

/**** DRIVEELEC ****/
function getDriveElecWifiList(middleware, fheCenter_mac) {
    return () => {
        return getSocket(middleware)
            .getDriveElecWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getDriveElecWifiListFhe - ', error);
                throw error;
            });
    };
}
function startDriveElecInclusion(middleware, fheCenter_mac, network, step_callback) {
    return () => {
        return getSocket(middleware)
            .startDriveElecInclusion(fheCenter_mac, network, step_callback)
            .catch(error => {
                Logger.log('dataActions: startDriveElecInclusionFhe - ', error);
                throw error;
            });
    };
}
function driveElecOlimexMigration(middleware, fheCenter_mac, product_identifier) {
    return () => {
        return getSocket(middleware)
            .driveElecOlimexMigration(fheCenter_mac, product_identifier)
            .catch(error => {
                Logger.log('dataActions: driveElecOlimexMigration - ', error)
                throw error;
            });
    }
}
/**** !DRIVEELEC ****/

/**** HEATANDCOOL ****/
function getHeatAndCoolWifiList(middleware, fheCenter_mac) {
    return () => {
        return getSocket(middleware)
            .getHeatAndCoolWifiList(fheCenter_mac)
            .catch(error => {
                Logger.log('dataActions: getHeatAndCoolWifiListFhe - ', error);
                throw error;
            });
    };
}
function startHeatAndCoolInclusion(middleware, fheCenter_mac, network, step_callback) {
    return () => {
        return getSocket(middleware)
            .startHeatAndCoolInclusion(fheCenter_mac, network, step_callback)
            .catch(error => {
                Logger.log('dataActions: startHeatAndCoolInclusionFhe - ', error);
                throw error;
            });
    };
}
/**** !HEATANDCOOL ****/

export {
    updateGain,
    getProductsByHomeId,
    getProducts,
    getProductsDetails,
    refreshProductStatus,
    updateProductModuleLabel,
    updateProductField,
    updateProductModule,
    dissociateProduct,
    updateThreshold,
    updateReversePolarity,
    resetRelaysInversions,
    getSensorWifiList,
    startSensorInclusion,
    getSmartPlugWifiList,
    startSmartPlugInclusion,
    getFheProductWifiList,
    startFheProductInclusion,
    getDriveElecWifiList,
    startDriveElecInclusion,
    driveElecOlimexMigration,
    getHeatAndCoolWifiList,
    startHeatAndCoolInclusion,
    deleteProduct
};



// WEBPACK FOOTER //
// ./environments/fhe/data/Products/actions.js